export default[
    
    {
        path: '/afastamento/trabalhador/cadastro/:trabalhador_id',
        name: 'cadastro de afastamento do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/afastamento/trabalhador/lista/:id',
        name: 'lista de afastamento do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/afastamento/trabalhador/editar/:id/:trabalhador_id',
        name: 'editar afastamento do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]